////////
// Fund
////////
var Fund = function(el) {

	this.selectors = {
		thumb: ".fund-thumb",
		graphic: ".fund-graphic",
		moreButton: ".fund-more",
		fundName: "data-fund-slug",
		investmentsWrapper: ".block-funds-timeline .investments",
		fundInvesments: ".fund-investments"
	};

	this.flags = {
		ACTIVE: "active"
	};

	this.events = {
		HIDE_ALL_INVESTMENTS: "hideAllInvestments"
	}

	// Get objects
	this.element = $(el);
	this.allFunds = $(this.selectors.thumb);
	this.fundName = this.element.attr(this.selectors.fundName);
	this.moreButton = this.element.find(this.selectors.moreButton);
	this.graphic = this.element.find(this.selectors.graphic);
	this.investmentsWrapper = $(this.selectors.investmentsWrapper);
	this.allInvestments = this.investmentsWrapper.find(this.selectors.fundInvesments);
	this.investments = this.investmentsWrapper.find(this.selectors.fundInvesments + "[" + this.selectors.fundName + "='" + this.fundName + "']");
	this.allInvestmentsCallback = false;

	// Store
	this.activeFund = false;

	// Set events
	this.moreButton.on("click", this, this.toggleInvestments);
	this.graphic.on("click", this, this.toggleInvestments);
}


//******
// Hide investments
//******
Fund.prototype.hideInvestments = function(e) {
	var obj = e ? e.data : this;

	// Animate
	gsap.fromTo(obj.investments, {
		autoAlpha: 1,
	}, {
		duration:1,
		autoAlpha: 0,
		ease: Cubic.easeInOut
	});

	gsap.fromTo(obj.investmentsWrapper, { height:"auto" }, { duration:1, delay:.5, height: 0, ease: Cubic.easeInOut, onComplete: function() {
		obj.element.removeClass(obj.flags.ACTIVE);
		obj.moreButton.removeClass(obj.flags.ACTIVE);
		obj.investments.removeClass(obj.flags.ACTIVE);
		obj.investmentsWrapper.removeClass(obj.flags.ACTIVE);
	} });
}


//******
// Show investments
//******
Fund.prototype.toggleInvestments = function(e) {
	var obj = e ? e.data : this;

	// Is this fund already open?
	if(obj.element.hasClass(obj.flags.ACTIVE)) {

		// Close this fund
		obj.allFunds.removeClass(obj.flags.ACTIVE);
		obj.element.removeClass(obj.flags.ACTIVE);
		obj.moreButton.removeClass(obj.flags.ACTIVE);

		gsap.fromTo(obj.investments, {
			autoAlpha: 1,
	  }, {
			duration:1,
	    autoAlpha: 0,
			display:'none',
	    ease: Cubic.easeInOut
  	});

		gsap.fromTo(obj.investmentsWrapper, {
			height:"auto"
		}, {
			duration:1,
			delay:.5,
			height: 0,
			ease: Cubic.easeInOut,
			onComplete: function() {
				obj.investmentsWrapper.removeClass(obj.flags.ACTIVE);
				obj.investments.removeClass(obj.flags.ACTIVE);
			}
		});

		// Remove active fund
		this.activeFund = false;

	} else {


		// Remove active state on other thumbs
		obj.allFunds.removeClass(obj.flags.ACTIVE);
		obj.allFunds.find(".fund-more").removeClass(obj.flags.ACTIVE);

		// Is the investments panel already open?
		if(!obj.investmentsWrapper.hasClass(obj.flags.ACTIVE)) {
			gsap.fromTo(obj.investmentsWrapper, { height:0 }, { duration:1, height: "auto", ease: Cubic.easeInOut });
		}

		// Hide any other investments
		obj.allInvestments.removeClass(obj.flags.ACTIVE);
		obj.allInvestments.attr("style", "");

		// Add active state class
		obj.element.addClass(obj.flags.ACTIVE);
		obj.moreButton.addClass(obj.flags.ACTIVE);
		obj.investmentsWrapper.addClass(obj.flags.ACTIVE);
		obj.investments.addClass(obj.flags.ACTIVE);

		// Animate
		gsap.fromTo(obj.investments, {
			autoAlpha: 0,
	  }, {
			delay:.5,
			duration:1,
			display:"flex",
	    autoAlpha: 1,
	    ease: Cubic.easeInOut
	  });
	}

	return(false);
}
